define.alias("ember-cli-string-helpers/helpers/camelize", "settings/helpers/camelize");